import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete';
import InputBase from '@mui/material/InputBase';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';
import { ChevronDown } from 'lucide-react';
import * as React from 'react';
import { useMemo } from 'react';
import _ from 'underscore';

const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({})) as typeof Autocomplete;

export type Option = {
  id: string;
  label: string;
};

type Props = {
  params: GridRenderEditCellParams<Option>;
  options: Option[];
};

const DataGridAutocomplete: React.FC<Props> = ({ params, options }) => {
  const { id, value, field } = params;
  const apiRef = useGridApiContext();

  const handleChange = React.useCallback<NonNullable<AutocompleteProps<Option, false, true, false>['onChange']>>(
    async (event, newValue) => {
      await apiRef.current.setEditCellValue({ id, field, value: newValue }, event);
      apiRef.current.stopCellEditMode({ id, field });
    },
    [apiRef, field, id]
  );

  const sortedOptions = useMemo(() => {
    return _.sortBy(options, (option) => option.label.toLowerCase() || '');
  }, [options]);

  return (
    <StyledAutocomplete<Option, false, true, false>
      value={value}
      onChange={handleChange}
      options={sortedOptions}
      getOptionLabel={(option: any) => option.label || ''}
      autoHighlight
      fullWidth
      open
      slotProps={{
        paper: {
          sx: {
            width: 'max-content',
          },
        },
      }}
      disableClearable
      renderOption={(optionProps, option: any) => {
        return (
          <Box component="li" {...optionProps} key={option.id}>
            {option.label}
          </Box>
        );
      }}
      popupIcon={<ChevronDown size={18} />}
      renderInput={(params) => (
        <InputBase
          autoFocus
          fullWidth
          id={params.id}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
          }}
          {...params.InputProps}
        />
      )}
    />
  );
};

export default DataGridAutocomplete;
